// extracted by mini-css-extract-plugin
export default {"innerContainer":"styles-module--innerContainer--D-BpR","detailsLink":"styles-module--detailsLink--DgUBx","virtualTourColumn":"styles-module--virtualTourColumn---IDPO"};